// export const baseUrl = "http://111.118.189.135/dccc/api/v1/";
// export const baseUrl = "http://10.189.10.111:4200/dccc/api/v1/"; //prod url
// export const baseUrl = "https://ncd-staging.mohfw.gov.in/dccc/api/v1/"; //prod url
// export const baseUrl = "http://172.16.14.43:4200/api/v1/";
export const baseUrl = "/dccc/api/v1/";

export const aesKey = "LQ8yCTiDOFQFk8FFo1CpftkBoBnEIJmu";
export const aesIv = "213A26DBB4A358C5";
export const ENCRYPTION_ALGORITHM = "aes - 256 - cbc"